export default __webpack_public_path__ + "static/media/metrics-icon.60044f26.svg";